export default __webpack_public_path__ + "static/media/dubaiToCanada.23967424.svg";